import loadProductGroupModule from './modules/ProductGroup.module';
import loadWishListModule from './modules/WishList.module';
import loadCompareModule from './modules/Compare.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
const loadProductGroupRootModule = (initialData) => ({
    hasRouter: false,
    modules: [
        loadCompareModule(),
        loadProductGroupModule(initialData),
        loadWishListModule(),
        loadDeliveryPromiseModule(),
    ],
});
export default loadProductGroupRootModule;
